// import { useEffect } from 'react';
// import { config } from './CommonUtils/CommonURLS';
// import { CommonAxiosGet } from './CommonUtils/CommonAxios';

// import { embedDashboard } from "@superset-ui/embedded-sdk";

// function Superset() {

//     function getGuestToken() {
//         CommonAxiosGet(config.url.API_URL + 'dashboard/guest-token', {})
//             .then(function (response) {
//                 console.log("Guest Token Response:", response);
//                 embedDashboard({
//                     id: "f576b26d-f3c5-4f91-ad87-e4d130f590d4",
//                     supersetDomain: "https://supersetpreprd.apcfss.in/",
//                     mountPoint: document.getElementById("superset-container"),
//                     fetchGuestToken: () => response?.data?.token,
//                     dashboardUiConfig: { hideTitle: true }
//                 });
//             }).catch(function (error) { console.log(error); });

//         // embedDashboard({
//         //   id: "20fc2506-53e0-4d6e-9950-efc38dc8dcda",
//         //   supersetDomain: "https://supersetpreprd.apcfss.in/",
//         //   mountPoint: document.getElementById("superset-container"),
//         //   fetchGuestToken: () => "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjp7ImZpcnN0X25hbWUiOiJmaXJzdG5hbWUiLCJ1c2VybmFtZSI6ImpuYW5hYmh1bWlfZGFzaGJvYXJkIiwibGFzdF9uYW1lIjoibGFzdG5hbWUifSwicmVzb3VyY2VzIjpbeyJ0eXBlIjoiZGFzaGJvYXJkIiwiaWQiOiIyMGZjMjUwNi01M2UwLTRkNmUtOTk1MC1lZmMzOGRjOGRjZGEifV0sInJsc19ydWxlcyI6W10sImlhdCI6MTcyODQ4NjY2OC40NzI3MzczLCJleHAiOjE3Mjg0ODY5NjguNDcyNzM3MywiYXVkIjoiaHR0cDovLzAuMC4wLjA6ODA4MC8iLCJ0eXBlIjoiZ3Vlc3QifQ.OqR5zLuiiV57SUmevI-zq58h0vdE4kIBuE_WyClEm-w",
//         //   dashboardUiConfig: { hideTitle: true }
//         // });
//         // embedDashboard({
//         //     id: "f576b26d-f3c5-4f91-ad87-e4d130f590d4",
//         //     supersetDomain: "https://supersetpreprd.apcfss.in/",
//         //     mountPoint: document.getElementById("superset-container-nn"),
//         //     fetchGuestToken: () => "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjp7Imxhc3RfbmFtZSI6Imxhc3RuYW1lIiwidXNlcm5hbWUiOiJqbmFuYWJodW1pX2Rhc2hib2FyZCIsImZpcnN0X25hbWUiOiJmaXJzdG5hbWUifSwicmVzb3VyY2VzIjpbeyJ0eXBlIjoiZGFzaGJvYXJkIiwiaWQiOiJmNTc2YjI2ZC1mM2M1LTRmOTEtYWQ4Ny1lNGQxMzBmNTkwZDQifV0sInJsc19ydWxlcyI6W10sImlhdCI6MTc3NDk0NzQwOS42MDkxMjgsImV4cCI6MTc3NDk0NzcwOS42MDkxMjgsImF1ZCI6Imh0dHA6Ly8wLjAuMC4wOjgwODAvIiwidHlwZSI6Imd1ZXN0In0.tGZUKamjl-HqUJhiu0QZMMDIj-GNxRBHbrqJr37VSiw",
//         //     dashboardUiConfig: { hideTitle: true }
//         // });
//     }

//     useEffect(() => {
//         getGuestToken();
//     }, [])




//     return (
//         <>
//             <h4>Sample Dashboard</h4>
//             <div id="superset-container-nn" style={{ width: "100vw", height: "22vh" }}></div>
//         </>
//     );
// }

// export default Superset;


import React, { useEffect, useRef, useState } from "react";
import { config } from './CommonUtils/CommonURLS';
import '../src/App.css';

import { CommonAxiosGet } from './CommonUtils/CommonAxios';
import { embedDashboard } from "@superset-ui/embedded-sdk";

function Superset() {
    function getGuestToken() {
        CommonAxiosGet(config.url.API_URL + 'dashboard/guest-token', {})
            .then(function (response) {
                console.log("Guest Token Response:", response);
                embedDashboard({
                    id: "f576b26d-f3c5-4f91-ad87-e4d130f590d4",
                    supersetDomain: "https://supersetpreprd.apcfss.in/",
                    mountPoint: document.getElementById("superset-container"), // ✅ matches JSX below
                    fetchGuestToken: () => response?.data?.token,
                    dashboardUiConfig: { hideTitle: true }
                });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    // Call getGuestToken when component mounts
    React.useEffect(() => {
        getGuestToken();
    }, []);

    return (
        <>
            <h4>Affiliation Dashboard</h4>
            <div
                id="superset-container"
                style={{ width: "100vw", height: "22vh" }}
            ></div>
        </>
    );
}

export default Superset;

